import service from '@/store/services/fms/pko-service';

const state = {
  list: {},
  pko: {},
  meta: {},
  blob: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, pko) => {
    state.pko = pko;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_BLOB: (state, blob) => {
    state.blob = blob;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },


  get({commit, dispatch}, params) {
    return service.get(params)
      .then((pko) => { commit('SET_RESOURCE', pko); });
  },


  add({commit, dispatch}, params) {
    return service.add(params)
      .then((pko) => { commit('SET_RESOURCE', pko); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((pko) => { commit('SET_RESOURCE', pko); });
  },

  update_status({commit, dispatch}, params) {
    return service.update_status(params)
      .then((pko) => { commit('SET_RESOURCE', pko); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((pko) => { commit('SET_RESOURCE', pko); });
  },

  download_doc_agreement({commit, dispatch}, params) {
    return service.download_doc_agreement(params)
      .then((blob) => { commit('SET_BLOB', blob); });
  },


};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  pko: state => state.pko,
  page: state => state.meta.page,
  blob: state => state.blob,

};
 
const pko = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default pko;
